/**
 * Landing/VehicleAppraiser Route - React Router v7
 *
 * Route: /tasacion-de-coches (coches only)
 */
/* eslint-disable no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import VehicleAppraiser from './index.js'
import {vehicleAppraiserInitialProps} from './vehicleAppraiserInitialProps.js'

import './styles/index.scss'

export async function loader({context}: LoaderFunctionArgs) {
  try {
    return await vehicleAppraiserInitialProps({context})
  } catch (error: unknown) {
    console.error('[RR7] VehicleAppraiser loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <VehicleAppraiser {...(data as object)} />
}

Component.displayName = 'VehicleAppraiserRoute'
